import { type TranslationTree } from '@/i18n/types';

export const messages = {
  cancel: 'Cancelar',
  continue: 'Continuar',
  body: 'Informe o e-mail da conta e enviaremos um link para redefinir a senha.',
  sent: 'Se o e-mail estiver cadastrado, o link chega em instantes',
  title: 'Redefinir senha',
  email: 'E-mail',
} satisfies TranslationTree;
